/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { acknowledgeAllAlarmsStation } from '../fn/sites-alarmes/acknowledge-all-alarms-station';
import { AcknowledgeAllAlarmsStation$Params } from '../fn/sites-alarmes/acknowledge-all-alarms-station';
import { acknowledgeStationAlarm } from '../fn/sites-alarmes/acknowledge-station-alarm';
import { AcknowledgeStationAlarm$Params } from '../fn/sites-alarmes/acknowledge-station-alarm';
import { AlarmRealTimePaginatedList } from '../models/alarm-real-time-paginated-list';
import { exportAlarms } from '../fn/sites-alarmes/export-alarms';
import { exportAlarms$Any } from '../fn/sites-alarmes/export-alarms-any';
import { ExportAlarms$Any$Params } from '../fn/sites-alarmes/export-alarms-any';
import { ExportAlarms$Params } from '../fn/sites-alarmes/export-alarms';
import { exportStationAlarms } from '../fn/sites-alarmes/export-station-alarms';
import { exportStationAlarms$Any } from '../fn/sites-alarmes/export-station-alarms-any';
import { ExportStationAlarms$Any$Params } from '../fn/sites-alarmes/export-station-alarms-any';
import { ExportStationAlarms$Params } from '../fn/sites-alarmes/export-station-alarms';
import { getStationAlarmsSearch } from '../fn/sites-alarmes/get-station-alarms-search';
import { getStationAlarmsSearch$Any } from '../fn/sites-alarmes/get-station-alarms-search-any';
import { GetStationAlarmsSearch$Any$Params } from '../fn/sites-alarmes/get-station-alarms-search-any';
import { GetStationAlarmsSearch$Params } from '../fn/sites-alarmes/get-station-alarms-search';
import { searchAlarms } from '../fn/sites-alarmes/search-alarms';
import { searchAlarms$Any } from '../fn/sites-alarmes/search-alarms-any';
import { SearchAlarms$Any$Params } from '../fn/sites-alarmes/search-alarms-any';
import { SearchAlarms$Params } from '../fn/sites-alarmes/search-alarms';
import { unacknowledgeStationAlarm } from '../fn/sites-alarmes/unacknowledge-station-alarm';
import { UnacknowledgeStationAlarm$Params } from '../fn/sites-alarmes/unacknowledge-station-alarm';

@Injectable({ providedIn: 'root' })
export class SitesAlarmesService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getStationAlarmsSearch()` */
  static readonly GetStationAlarmsSearchPath = '/stations/{uid}/alarms/search';

  /**
   * Get all active alarms for a station.
   *
   * Get all active alarms for a station.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationAlarmsSearch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getStationAlarmsSearch$Response(params: GetStationAlarmsSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<AlarmRealTimePaginatedList>> {
    return getStationAlarmsSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all active alarms for a station.
   *
   * Get all active alarms for a station.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationAlarmsSearch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getStationAlarmsSearch(params: GetStationAlarmsSearch$Params, context?: HttpContext): Observable<AlarmRealTimePaginatedList> {
    return this.getStationAlarmsSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<AlarmRealTimePaginatedList>): AlarmRealTimePaginatedList => r.body)
    );
  }

  /**
   * Get all active alarms for a station.
   *
   * Get all active alarms for a station.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationAlarmsSearch$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getStationAlarmsSearch$Any$Response(params: GetStationAlarmsSearch$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<AlarmRealTimePaginatedList>> {
    return getStationAlarmsSearch$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all active alarms for a station.
   *
   * Get all active alarms for a station.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationAlarmsSearch$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getStationAlarmsSearch$Any(params: GetStationAlarmsSearch$Any$Params, context?: HttpContext): Observable<AlarmRealTimePaginatedList> {
    return this.getStationAlarmsSearch$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<AlarmRealTimePaginatedList>): AlarmRealTimePaginatedList => r.body)
    );
  }

  /** Path part for operation `exportStationAlarms()` */
  static readonly ExportStationAlarmsPath = '/stations/{uid}/alarms/active/export';

  /**
   * export alarms of a station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportStationAlarms()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportStationAlarms$Response(params: ExportStationAlarms$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportStationAlarms(this.http, this.rootUrl, params, context);
  }

  /**
   * export alarms of a station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportStationAlarms$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportStationAlarms(params: ExportStationAlarms$Params, context?: HttpContext): Observable<Blob> {
    return this.exportStationAlarms$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * export alarms of a station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportStationAlarms$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  exportStationAlarms$Any$Response(params: ExportStationAlarms$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportStationAlarms$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * export alarms of a station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportStationAlarms$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  exportStationAlarms$Any(params: ExportStationAlarms$Any$Params, context?: HttpContext): Observable<Blob> {
    return this.exportStationAlarms$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `acknowledgeAllAlarmsStation()` */
  static readonly AcknowledgeAllAlarmsStationPath = '/stations/{uid}/alarms/ack';

  /**
   * Acknowledge all active alarms of a station.
   *
   * Acknowledge all active alarms of a station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `acknowledgeAllAlarmsStation()` instead.
   *
   * This method doesn't expect any request body.
   */
  acknowledgeAllAlarmsStation$Response(params: AcknowledgeAllAlarmsStation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return acknowledgeAllAlarmsStation(this.http, this.rootUrl, params, context);
  }

  /**
   * Acknowledge all active alarms of a station.
   *
   * Acknowledge all active alarms of a station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `acknowledgeAllAlarmsStation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  acknowledgeAllAlarmsStation(params: AcknowledgeAllAlarmsStation$Params, context?: HttpContext): Observable<void> {
    return this.acknowledgeAllAlarmsStation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `acknowledgeStationAlarm()` */
  static readonly AcknowledgeStationAlarmPath = '/stations/{uid}/alarms/{alarmUid}/ack';

  /**
   * Acknowledge a station's alarm.
   *
   * Acknowledge a station's alarm
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `acknowledgeStationAlarm()` instead.
   *
   * This method doesn't expect any request body.
   */
  acknowledgeStationAlarm$Response(params: AcknowledgeStationAlarm$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return acknowledgeStationAlarm(this.http, this.rootUrl, params, context);
  }

  /**
   * Acknowledge a station's alarm.
   *
   * Acknowledge a station's alarm
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `acknowledgeStationAlarm$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  acknowledgeStationAlarm(params: AcknowledgeStationAlarm$Params, context?: HttpContext): Observable<void> {
    return this.acknowledgeStationAlarm$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `unacknowledgeStationAlarm()` */
  static readonly UnacknowledgeStationAlarmPath = '/stations/{uid}/alarms/{alarmUid}/un-ack';

  /**
   * Unacknowledge a station's alarm.
   *
   * Unacknowledge a station's alarm
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unacknowledgeStationAlarm()` instead.
   *
   * This method doesn't expect any request body.
   */
  unacknowledgeStationAlarm$Response(params: UnacknowledgeStationAlarm$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return unacknowledgeStationAlarm(this.http, this.rootUrl, params, context);
  }

  /**
   * Unacknowledge a station's alarm.
   *
   * Unacknowledge a station's alarm
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unacknowledgeStationAlarm$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  unacknowledgeStationAlarm(params: UnacknowledgeStationAlarm$Params, context?: HttpContext): Observable<void> {
    return this.unacknowledgeStationAlarm$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchAlarms()` */
  static readonly SearchAlarmsPath = '/alarms/search';

  /**
   * search alarms.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAlarms()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAlarms$Response(params?: SearchAlarms$Params, context?: HttpContext): Observable<StrictHttpResponse<AlarmRealTimePaginatedList>> {
    return searchAlarms(this.http, this.rootUrl, params, context);
  }

  /**
   * search alarms.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAlarms$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAlarms(params?: SearchAlarms$Params, context?: HttpContext): Observable<AlarmRealTimePaginatedList> {
    return this.searchAlarms$Response(params, context).pipe(
      map((r: StrictHttpResponse<AlarmRealTimePaginatedList>): AlarmRealTimePaginatedList => r.body)
    );
  }

  /**
   * search alarms.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAlarms$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchAlarms$Any$Response(params?: SearchAlarms$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<AlarmRealTimePaginatedList>> {
    return searchAlarms$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * search alarms.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAlarms$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchAlarms$Any(params?: SearchAlarms$Any$Params, context?: HttpContext): Observable<AlarmRealTimePaginatedList> {
    return this.searchAlarms$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<AlarmRealTimePaginatedList>): AlarmRealTimePaginatedList => r.body)
    );
  }

  /** Path part for operation `exportAlarms()` */
  static readonly ExportAlarmsPath = '/alarms/export';

  /**
   * export alarms.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportAlarms()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportAlarms$Response(params?: ExportAlarms$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportAlarms(this.http, this.rootUrl, params, context);
  }

  /**
   * export alarms.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportAlarms$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportAlarms(params?: ExportAlarms$Params, context?: HttpContext): Observable<Blob> {
    return this.exportAlarms$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * export alarms.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportAlarms$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  exportAlarms$Any$Response(params?: ExportAlarms$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportAlarms$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * export alarms.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportAlarms$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  exportAlarms$Any(params?: ExportAlarms$Any$Params, context?: HttpContext): Observable<Blob> {
    return this.exportAlarms$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
